import { PartialRecord } from "@base/util/TypeUtil";
import { OrderType } from "@biz/Definitions";
import { ArticleListType } from "@biz/definitions/ArticleDefinitions";
import { ProductVersion } from "@biz/definitions/ProductVersion";
import { PoleId, SunSailType } from "@biz/definitions/SunSailDefinitions";
import { Poles } from "@biz/items/sunSail/logic/Poles";
import { INotesAndFilesExtendedItem } from "@biz/models/NotesAndFiles";
import { IPartListArticleItem, IPartListProject, IPartListProjectArgs, IPartListShoppingCartChapter, IPartListSunSailChapter, PoleItem } from "@biz/models/PartListDefinitions";
import { IExtOrderSlot } from "@biz/models/SceneOrderHelper";
import { PD } from "@biz/PD";
import { IProductDescriptor } from "@biz/ProductDescriptor";
import { IProjectCheckError } from "@biz/projectCalculation/ProjectDefinitions";

export class PartListHelper {
  static getHardwarePoles(chapter: IPartListSunSailChapter): PoleItem[] {
    return [...chapter.poleList, ...chapter.centerPoleList]
  }
  static getHardwarePole(chapter: IPartListSunSailChapter, poleId: PoleId): PoleItem {
    const pid = Poles.fromPoleId(poleId);
    if (pid.polePositionType === "center")
      return chapter.centerPoleList[pid.poleIndex];
    return chapter.poleList[pid.poleIndex]
  }

  static getChapterArticles(articleMap: PartialRecord<ArticleListType, IPartListArticleItem[]>, type: ArticleListType): IPartListArticleItem[] {
    let articles = articleMap[type];
    if (!articles) {
      articles = [];
      articleMap[type] = articles;
    }
    return articles;
  }

  static createProjectArgs(): IPartListProjectArgs {
    return {
      companyName: "",
      companyId: -1,
      userId: "",
      appOrderId: "",
      commission: "",
      variantName: "",
      country: "",
      countryCode: "",
      language: "",
    };
  }

  static createSunSailChapter(pd: IProductDescriptor, orderSlots: PartialRecord<OrderType, IExtOrderSlot>, version: ProductVersion | undefined, productIndex: number, orderType: OrderType, errors: IProjectCheckError[], notesAndFiles: INotesAndFilesExtendedItem[]): IPartListSunSailChapter {
    return {
      type: "sunSail",
      sourceType: "app",
      products: [{ index: productIndex, pd, version, orderSlots, orderType, errors, notesAndFiles }],
      sunSailType: SunSailType.None,
      poleMaterialText: "",
      poleCount: 4,
      pylonCount: 0,
      // axle: { length: 0, exactLength: 0, items: [] },
      motorWithRadio: 0,

      articles: {},
      poleList: [],
      centerPoleList: [],
      powderCoatingArticles: [],
      unhandledList: [],

      infos: {
        hardware: [],
        sailInfo: [],
        measuresCS: [],
        netLengths: [],
        mountLengths: [],
        distIns: [],
        corners: [],
        concavities: [],
        edgeInfos: [],
      },
    };
  }

  static createShoppingCartArgs(): IPartListShoppingCartChapter {
    return {
      type: "shoppingCart",
      products: [{ index: -1, pd: PD.interned({ pdt: "shoppingCart", itemType: "shoppingCart", version: "2022" }), version: "2022", orderSlots: {}, orderType: "H", errors: [], notesAndFiles: [] }],
      sourceType: "shop",
      unhandledList: [],
      powderCoatingArticles: [],
      articles: {}
    };
  }

  static createArticle(): IPartListArticleItem {
    return {
      name: "",
      count: undefined,
      length: 0,
      groupPriority: 100,
      priority: 100,
      articleNumber: "",
      unit: undefined,
      countClientAvailable: 0,
      mulInput: 1,
      mulUnit: undefined,
      powderCoating: undefined
    };
  }

  static createProject(): IPartListProject {
    return {
      project: PartListHelper.createProjectArgs(),
      chapters: [],
      shoppingCart: PartListHelper.createShoppingCartArgs(),
      reviewer: "",
      offer: {
        errors: []
      },
      projectErrors: []
    };
  }
}